import React, { createContext } from 'react';

const CollaborateQAContext = createContext();

export default CollaborateQAContext;